import { SERIE_LIST_GQL } from './gql';
import { apolloClient } from '../client';
import { Serie } from '../types.generated';

export const serieListQuery = async (): Promise<Serie[] | null> => {
  const response = await apolloClient.query<{ series: Serie[] }>({
    query: SERIE_LIST_GQL,
    variables: {},
    fetchPolicy: 'network-only',
  });

  return response.data ? response.data.series : null;
};
